export default "__VITE_ASSET__AcoiNcmL__"